import { get } from "svelte/store";
import ApiParams from "../stores/ApiParams";
import User from "../stores/User";
let apiParams = get(ApiParams);
let user: User;
User.subscribe((value) => {
  user = value;
});

// TODO: switch to not modifiying window.fetch and using modifiedFetch
let { fetch: fetchWithAuth } = window; //retain unmodified version of fetch

// @ts-ignore
function initModifyFetch() {
  /**
   * modified version of fetch handles both WCS authentication check as
   * well as JWT auth check and either returns unmodified fetch call, returns
   * unmodified fetch with fresh JWT or redirects user to login
   * @param URL url to fetch
   * @param options headers
   * @param checkWebSession option to skip websession auth check. true by default
   */
  // @ts-ignore
  fetchWithAuth = async (URL, options, checkWebSession = true) => {
    if (checkWebSession) {
      const checkAuth = debounceAuthCheck();
      if (checkAuth) {
        const authStatus = await getAuthStatus();
        if (authStatus.userType === "G") {
          //if user is guest ie not auth'd
          redirectToLogin();
          return;
        }
      }
    }
    //unmodifiedFetchPromise is used to read the response to make sure the JWT is fresh
    let unmodifiedFetchPromise = fetch(URL, options);

    //read unmodified fetch promise to ensure JWT is valid
    const response = await unmodifiedFetchPromise;

    if (response.status === 401) {
      user = await getUserAccount(); //get fresh JWT

      // @ts-ignore
      if (options?.headers?.Authorization) {
        //set authorization with fresh JWT
        // @ts-ignore
        options.headers.Authorization = "Bearer " + user.jwtToken;
      } else {
        return unmodifiedFetchPromise;
      }

      return fetch(URL, options); //rerun call with fresh jwt
    } else {
      return unmodifiedFetchPromise;
    }
  };
  // @ts-ignore
  window.FETCH_IS_MODIFIED = true; //check to ensure fetch is modified
}

//---------- Function Definitions

/**
 * Hit /getuserdetails API endpoint to retrieve account info and generate a
 * fresh JWT
 * If user is not authenticated, redirect to login page
 *
 * @returns user object with newly generated JWT
 */
async function getUserAccount() {
  try {
    const response = await fetch(apiParams.getUserDetails, {
      method: "GET",
    });
    const data = await response.json();
    if ((data.errors && data.errors.length > 0) || data.userType == "Guest") {
      redirectToLogin();
    } else {
      console.log(data);
      return setAccountInfo(data);
    }
  } catch (error) {
    console.error(error);
  }

  /**
   * Sets user object with entire account info and quick properties for most
   * heavily used user attributes
   *
   * @returns formatted user object
   */
  function setAccountInfo(data) {
    const user: User = {
      accountInfo: data,
      jwtToken: data.jwttoken,
      accountNumber: data.accountList.filter((account) => {
        return account.isSelected;
      })[0].accountNumber,
      lastAuthenticated: Date.now(),
    };
    console.log(user);
    return user;
  }
}

/**
 * getAuthStatus uses /hdsauth to check WCS auth status.
 * /hdsAuth is a page, not a REST endpoint. As such it returns a jsp when
 * user is not authenticated (thus <!-- Begin... returns userType = "G").
 * If user is authenticated, the server incorrectly returns an object
 * wrapped in js comment syntax. The comments are removed and pass to JSON.parse
 */
async function getAuthStatus() {
  const response = await fetch(apiParams.checkHdsAuth, {
    method: "GET",
  });
  const text = await response.text();
  const statusCode = Number(response.status);
  //returns user type as guest if response is jsp
  if (statusCode === 400 || (text && text.indexOf("<!-- BEGIN UserTimeoutView.jsp -->") !== -1)) {
    return { userType: "G" };
  } else {
    //sanitize malformed repsonse and return hdsauth json object
    return JSON.parse(text.substring(text.indexOf("/*") + 2, text.indexOf("*/")));
  }
}

/**
 * Debounce WCS authorization every 60000ms
 */
function debounceAuthCheck() {
  const debounceTime = 60000;
  if (user.lastAuthenticated + debounceTime > Date.now()) {
    return false;
  }
  //update last authenticated timestamp to start new debounce clock
  user.lastAuthenticated = Date.now();
  return true;
}

function redirectToLogin() {
  window.location.href = apiParams.login;
}

export { initModifyFetch as default, getUserAccount, fetchWithAuth };
